// extracted by mini-css-extract-plugin
module.exports = {"modal_wrap":"lifehack_modal-module__modal_wrap___sqa-R","modal__image":"lifehack_modal-module__modal__image___9zBzc"};